module.exports = __webpack_public_path__ + "static/media/hanakawado-asakusa-4.55ff9147.jpg";